import Campo from "../Campo";
import styles from "./styles.module.css";
import { Membro } from "../../model/Membro";
import { useContext, useEffect, useState } from "react";
import { cepMask, numberMask } from "../../controllers/Masks";
import { useMask } from "@react-input/mask";
import VerificaForm from "../../controllers/VerificaForm";
import { UserContext } from "../../context/UserContext";
import listarCidades from "../../services/listarCidades";
import CampoSelect from "../Campo/CampoSelect";
import putMembro from "../../services/putMembro";
import deleteMembros from "../../services/deleteMembros";

type Props = {
  listaMembros: Membro[];
  index: number;
  setMembros: React.Dispatch<React.SetStateAction<Membro[]>>;
  closeModal: Function;
};

const EditMembro = ({ listaMembros, index, setMembros, closeModal }: Props) => {
  const membroObj = listaMembros[index];
  const [cargo, setCargo] = useState(membroObj.cargo);
  const [email, setEmail] = useState(membroObj.email);

  const [cepEndereco, setCep] = useState(membroObj.endereco.cep);
  const [estadoEndereco, setEstado] = useState(membroObj.endereco.estado);
  const [cidadeEndereco, setCidade] = useState(membroObj.endereco.cidade);
  const [bairroEndereco, setBairro] = useState(membroObj.endereco.bairro);
  const [ruaEndereco, setRua] = useState(membroObj.endereco.rua);
  const [numeroEndereco, setNumero] = useState(membroObj.endereco.numero);
  const [listaCidades, setListaCidades] = useState(["", "Aquidauana"]);
  const [complementoEndereco, setComplemento] = useState(
    membroObj.endereco.complemento
  );

  useEffect(() => {
    const atualizarListaCidades = async () => {
      try {
        const response = await listarCidades(estadoEndereco);
        const cidades = response.map((c: any) => {
          return c.nome;
        });

        setListaCidades(cidades);
        if (estadoEndereco === "MS") {
          setCidade("Aquidauana");
        } else {
          setCidade(listaCidades[0]);
        }
      } catch (error) {
        console.error("Erro ao buscar cidades:", error);
      }
    };
    atualizarListaCidades();
  }, [estadoEndereco]);

  const { token } = useContext(UserContext);

  return (
    <form className={styles.formModal}>
      <h2>Editar dados do Membro</h2>
      <div className={styles.camposDados}>
        <hr />
        <div className={styles.gridCampos}>
          <span className={styles.tuplaDado}>
            <strong>Nome:</strong> {membroObj.nome}
          </span>
          <span className={styles.tuplaDado}>
            <strong>CPF:</strong> {membroObj.cpf}
          </span>
          <span className={styles.tuplaDado}>
            <strong>RG:</strong> {membroObj.rg}
          </span>
          <span className={styles.tuplaDado}>
            <strong>Órgão:</strong> {membroObj.orgao}
          </span>
        </div>
        <hr />
        <div className={styles.gridCampos}>
          <Campo
            title="Cargo"
            type="text"
            placeholder="Cargo"
            maxLength={64}
            required={true}
            value={cargo}
            setter={setCargo}
            customValidity="Preencha com o cargo deste membro"
          ></Campo>
          <Campo
            title="Email"
            type="text"
            placeholder="email_do_membro@email.com"
            maxLength={64}
            required={true}
            value={email}
            setter={setEmail}
            customValidity="Preencha com o email deste membro"
          ></Campo>
        </div>
        <hr className={styles.separador} />
        <h3 className={styles.subTitulo}>Endereço do Membro:</h3>
        <div className={styles.gridCampos}>
          <Campo
            title="CEP"
            type="text"
            placeholder="00000-000"
            minLength={9}
            required={true}
            customValidity="Preencha com o CEP da sua Instituição"
            setter={setCep}
            value={cepEndereco}
            mask={useMask(cepMask)}
          ></Campo>
          <CampoSelect title="Estado" setter={setEstado} value={estadoEndereco}>
            <option value="AC">Acre (AC)</option>
            <option value="AL">Alagoas (AL)</option>
            <option value="AP">Amapá (AP)</option>
            <option value="AM">Amazonas (AM)</option>
            <option value="BA">Bahia (BA)</option>
            <option value="CE">Ceará (CE)</option>
            <option value="DF">Distrito Federal (DF)</option>
            <option value="ES">Espírito Santo (ES)</option>
            <option value="GO">Goiás (GO)</option>
            <option value="MA">Maranhão (MA)</option>
            <option value="MT">Mato Grosso (MT)</option>
            <option value="MS">Mato Grosso do Sul (MS)</option>
            <option value="MG">Minas Gerais (MG)</option>
            <option value="PA">Pará (PA)</option>
            <option value="PB">Paraíba (PB)</option>
            <option value="PR">Paraná (PR)</option>
            <option value="PE">Pernambuco (PE)</option>
            <option value="PI">Piauí (PI)</option>
            <option value="RJ">Rio de Janeiro (RJ)</option>
            <option value="RN">Rio Grande do Norte (RN)</option>
            <option value="RS">Rio Grande do Sul (RS)</option>
            <option value="RO">Rondônia (RO)</option>
            <option value="RR">Roraima (RR)</option>
            <option value="SC">Santa Catarina (SC)</option>
            <option value="SP">São Paulo (SP)</option>
            <option value="SE">Sergipe (SE)</option>
            <option value="TO">Tocantins (TO)</option>
          </CampoSelect>
          <CampoSelect title="Cidade" setter={setCidade} value={cidadeEndereco}>
            {listaCidades &&
              listaCidades.map((cidade, index) => (
                <option value={cidade} key={index}>
                  {cidade}
                </option>
              ))}
          </CampoSelect>
          <Campo
            title="Bairro"
            type="text"
            placeholder="Bairro do seu Representante"
            maxLength={64}
            required={true}
            customValidity="Preencha com o Bairro da sua Instituição"
            setter={setBairro}
            value={bairroEndereco}
          ></Campo>
          <Campo
            title="Rua"
            type="text"
            placeholder="Rua do seu Representante"
            maxLength={64}
            required={true}
            customValidity="Preencha com a rua da sua Instituição"
            setter={setRua}
            value={ruaEndereco}
          ></Campo>
          <Campo
            title="Numero"
            type="text"
            placeholder="Numero do Imóvel do seu Representante"
            required={true}
            customValidity="Preencha com o numero do Imóvel"
            setter={setNumero}
            value={numeroEndereco}
            mask={useMask(numberMask)}
          ></Campo>
          <Campo
            title="Complemento"
            type="text"
            placeholder="Complemento do Imóvel"
            maxLength={128}
            required={false}
            customValidity="Preencha com o Complemento"
            setter={setComplemento}
            value={complementoEndereco}
          ></Campo>
        </div>
        <hr />
      </div>
      <div className={index > 0 ? styles.gridCampos : ""}>
        <input
          type="submit"
          value="+ Editar Dados"
          className={styles.editBtn}
          onClick={(e) => {
            e.preventDefault();
            const editarMembro = async () => {
              try {
                await putMembro(
                  token,
                  membroObj.cpf,
                  membroObj.nome,
                  membroObj.rg,
                  membroObj.orgao,
                  cargo || membroObj.cargo,
                  cepEndereco || membroObj.endereco.cep,
                  estadoEndereco || membroObj.endereco.estado,
                  cidadeEndereco || membroObj.endereco.cidade,
                  ruaEndereco || membroObj.endereco.rua,
                  bairroEndereco || membroObj.endereco.bairro,
                  numeroEndereco || membroObj.endereco.numero,
                  complementoEndereco || membroObj.endereco.complemento
                );
              } catch (error) {
                console.log("Erro ao editar membro");
                console.error(error);
              }
            };
            if (VerificaForm(e.currentTarget.form)) {
              editarMembro();
              listaMembros[index] = {
                nome: membroObj.nome,
                cargo: cargo || membroObj.cargo,
                cpf: membroObj.cpf,
                rg: membroObj.rg,
                orgao: membroObj.orgao,
                email: email || membroObj.email,
                representante: membroObj.representante,
                endereco: {
                  cep: cepEndereco || membroObj.endereco.cep,
                  estado: estadoEndereco || membroObj.endereco.estado,
                  cidade: cidadeEndereco || membroObj.endereco.cidade,
                  bairro: bairroEndereco || membroObj.endereco.bairro,
                  rua: ruaEndereco || membroObj.endereco.rua,
                  numero: numeroEndereco || membroObj.endereco.numero,
                  complemento:
                    complementoEndereco || membroObj.endereco.complemento,
                },
              };
              setMembros(listaMembros);
              closeModal();
            }
          }}
        />
        {index > 0 && (
          <button
            className={styles.removeBtn}
            onClick={(e) => {
              e.preventDefault();
              const removerMembro = async () => {
                try {
                  await deleteMembros(token, membroObj.cpf);
                } catch (error) {
                  console.log("Erro ao deletar Membro");
                  console.error(error);
                }
              };
              removerMembro();
              listaMembros = [
                ...listaMembros.slice(0, index),
                ...listaMembros.slice(index + 1),
              ];
              setMembros(listaMembros);
              closeModal();
            }}
          >
            {" "}
            - Excluir Membro
          </button>
        )}
      </div>
    </form>
  );
};

export default EditMembro;
